import React, { createContext, useContext, useState } from "react";

const CaseTokenContext = createContext();

export const CaseTokenProvider = ({ children }) => {

    const [caseAccessToken, setCaseAccessToken] = useState(null);
    const [caseTokenExpiry, setCaseTokenExpiry] = useState(null);
    const [caseRefreshToken, setCaseRefreshToken] = useState(null);
    const [caseTokenError, setCaseTokenError] = useState(null);

    console.log ('CaseTokenProvider caseToken=', caseAccessToken)

    return (
        <CaseTokenContext.Provider
            value={{caseAccessToken, setCaseAccessToken,
                caseRefreshToken, setCaseRefreshToken,
                caseTokenExpiry, setCaseTokenExpiry,
                caseTokenError, setCaseTokenError}}>
            {children}
        </CaseTokenContext.Provider>
    );
};

export const useCaseToken = () => useContext(CaseTokenContext);
